import React from "react";

const About = () => {
	return (
		<div className="text-center">
			<h1 className="logo-text mt-5">Under construction...</h1>
		</div>
	);
};

export default About;
